import { Logger } from "@faire/observability-core/logging";

export const { logger } = Logger.getLogger("IMAGE_PLATFORM_INFRASTRUCTURE");
